var map = {
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_00.jpg": 1975,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_01.jpg": 1976,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_02.jpg": 1977,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_03.jpg": 1978,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_04.jpg": 1979,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_05.jpg": 1980,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_06.jpg": 1981,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_07.jpg": 1982,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_08.jpg": 1983,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_09.jpg": 1984,
	"./Lightsaber Obi-Wan ANH - Img - Wip 4_10.jpg": 1985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1974;